import clsx from 'clsx'
import React from 'react'

type Props = {
  className?: string
  onClick: () => void
}

export const ApplyButton = ({ onClick, className = '' }: Props) => {
  return (
    <Button className={className} onClick={onClick}>
      Apply
    </Button>
  )
}
const Button = ({ className, ...props }: React.ComponentPropsWithoutRef<'button'>) => (
  <button
    {...props}
    className={clsx(
      'bg-action-primary rounded-b-2xl hover:bg-action-deemphasized text-white !text-center text-sm',
      className,
    )}
    style={{ fontWeight: 700, paddingBottom: '0.75rem' }}
  />
)
